<div class="partner-business-container">
    <div class="partner-business-content">
        <div class="partner-business-header">
            <div class="business-header-image">
                <img class="logo" [src]="'https:' + sponsorOnboardingCMSData?.businessDetailsIcon.fields.file.url" alt="business-icon">
            </div>
            <div class="business-header-details">
                <div class="header-title">
                    {{sponsorOnboardingCMSData?.businessDetailsLabel}}
                </div>
                <div class="header-desc">
                    {{sponsorOnboardingCMSData?.businessDetailsDesc}}
                </div>
            </div>
        </div>

        <div class="business-field-container">
            <div class="business-fields-primary">
                <app-custom-select-dropdown [fieldTitle]="getGenericLabels?.EntityType" [required]="true" [width]="100" [widthUnit]="'%'" [options]="entityTypesList"
                (valueChange)="valueChange($event, 'entityType')" [value]="partnerBusinessDetails.entityType">
                </app-custom-select-dropdown>

                <app-custom-text-field [fieldTitle]="getGenericLabels?.BusinessName" [width]="100" [widthUnit]="'%'" [required]="true" [value]="partnerBusinessDetails.businessName"
                (valueChange)="partnerBusinessValueChange($event, 'businessName')">
                </app-custom-text-field>
            </div>

            <div class="business-fields-secondary">
                <app-custom-text-field [fieldTitle]="getGenericLabels?.TradingName" [width]="100" [widthUnit]="'%'" [required]="true" [value]="partnerBusinessDetails.tradingName"
                (valueChange)="partnerBusinessValueChange($event, 'tradingName')">
                </app-custom-text-field>

                <app-custom-select-dropdown [fieldTitle]="getGenericLabels?.Industry" [required]="true" [width]="100" [widthUnit]="'%'" [options]="industryTypesList"
                (valueChange)="valueChange($event, 'industry')" [value]="partnerBusinessDetails.industry">
                </app-custom-select-dropdown>

                <app-custom-text-field [fieldTitle]="getGenericLabels?.RegistrationNumber" [width]="100" [widthUnit]="'%'" [required]="isRegistrationReq" [value]="partnerBusinessDetails.registrationNumber"
                (valueChange)="partnerBusinessValueChange($event, 'registrationNumber')">
                </app-custom-text-field>
            </div>

            <div class="business-fields-full">
                <!-- <app-search-select
                [fieldTitle]="getGenericLabels?.Address" [width]="100" [widthUnit]="'%'" [required]="true" [value]="partnerBusinessDetails.address"
                [forLocation]="true" [options]="locationAddressOptions" (valueChange)="locationAddressChange($event)" (search)="addressSearchValueChange($event)">
                </app-search-select> -->

                <div class="pac-card" id="pac-card">
                    <div id="pac-container" [ngStyle]="{'--label-content': '\'' + addressLabelContent + '\''}">
                        <input id="pac-input" type="text" placeholder="" [(ngModel)]="partnerBusinessDetails.address" #pacInput/>
                    </div>
                </div>
                <div id="map"></div>
                <div id="infowindow-content">
                    <span id="place-name" class="title"></span><br />
                    <span id="place-address"></span>
                </div>
            </div>
            <div class="divider"></div>
        </div>
    </div>
</div>